import { render, staticRenderFns } from "./userManager.vue?vue&type=template&id=10b0b3f6&"
import script from "./userManager.vue?vue&type=script&lang=js&"
export * from "./userManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports